import type { Expression, ExpressionName } from './Types';

import { chunk, zip, toPair, toBins } from './utils';

type Stopper = <T>(args: T[]) => [T | null, T][];

const extract = <T>(args: T[], pos: number) => chunk(args.slice(pos), 2) as [T, T][];

const stopper: Record<string, Stopper> = {
  interpolate: args => extract(args, 2),
  case: args => extract(args, 0).map(toPair),
  match: args => extract(args, 1).map(toPair),
  step: <T>(args: T[]) => toBins([...extract(args, 2), [null, args[1]]]) as [T | null, T][],
  literal: <T>(args: T[]) => [[...args, ...args]] as [T, T][],
};

const isExpression = (e: any) => Array.isArray(e) && !!e.length && typeof e[0] === 'string';

export type ParsedExpression<In, Out> = {
  name: string;
  stops: [In, Out][];
  inputs: In[];
  outputs: Out[];
  min: number;
  max: number;
  fieldName: string;
  isZoom: boolean;
};

const parse = (input: any): ParsedExpression<any, any> | null => {
  let [name, ...args] = isExpression(input)
    ? input as Expression
    : ['literal' as ExpressionName, input];
  let fieldName = "zoom";
  let isZoom = true;
  if (name === "interpolate"){
    if (args[1].length === 1){
      fieldName =  args[1][0];
    }else {
      fieldName =  args[1][1];
      isZoom = false;
    }
    
  }
  if (name === "match"){
   fieldName =  args[0][1];
  } 
  if (name === "case"){
    fieldName =  args[0][1][1];
    for (let index = 0; index < args.length-1; index+=2) {
      args[index] = `${args[index][0]} ${args[index][2]}`; //${args[index][1][1]} > 
    }
  } 
  var  stops = stopper[name]?.(args);
  if (!stops){
    name = 'literal';
    stops = [['black', 'black']]
  } // return null;

  // literal [Array(2)] ['black'] ['black'] NaN NaN Zoom Level
  const [inputs, outputs] = zip(...stops);
  const min = Math.min(...inputs as number[]); //.flat(2)
  const max = Math.max(...inputs as number[]); //.flat(2)
  return { name, stops, inputs, outputs, min, max,fieldName, isZoom };
};

export default { isExpression, parse };
